// src/utils/presensiUtils.js
export function getNonUmatData(p) {
  const n = p?.non_umat_pre_registration;

  return {
    name: p?.nonUmatName || n?.nonUmatName || "",
    phone: p?.nonUmatPhoneNo || n?.nonUmatPhoneNo || "",
    gender: p?.nonUmatGender || n?.nonUmatGender || "",
  };
}

export function computeEventStats(events = [], preRegistrations = []) {
  const perEvent = {};
  const totals = {
    pesertaMale: 0, pesertaFemale: 0,
    petugasMale: 0, petugasFemale: 0,
    donationTotal: 0,
  };

  const preTotals = {
    pesertaMale: 0, pesertaFemale: 0,
    petugasMale: 0, petugasFemale: 0,
  };

  // --- helper untuk ambil gender dari 3 tipe peserta ---
  function getGender(p) {
    // INTERNAL
    if (p.personType === "Internal" && p.umat) {
      return String(p.umat.gender || "").toLowerCase();
    }

    // EXTERNAL
    if (p.personType === "External" && p.external_person) {
      return String(p.external_person.gender || "").toLowerCase();
    }

    // NON-UMAT (pre-reg)
    if (p.personType === "NonUmat" && p.nonUmatGender) {
      const n = getNonUmatData(p);
      return String(n.gender || "").toLowerCase();
    }

    return ""; // unknown
  }

  function isMale(gender) {
    return (
      gender.includes("乾") ||
      gender.toLowerCase().includes("pria")
    );
  }

  // ===============================
  //   HITUNG PER EVENT (HADIR)
  // ===============================
  events.forEach((ev) => {
    perEvent[ev.id] = {
      eventDate: ev.eventDate,
      pesertaMale: 0, pesertaFemale: 0,
      petugasMale: 0, petugasFemale: 0,
      donationTotal: 0,
    };

    (ev.participants || []).filter(p => !p.deleted).forEach((p) => {
      const gender = getGender(p);
      const male = isMale(gender);
      const isPeserta = !!p.peserta;

      if (isPeserta) {
        if (male) perEvent[ev.id].pesertaMale++;
        else perEvent[ev.id].pesertaFemale++;
      } else {
        if (male) perEvent[ev.id].petugasMale++;
        else perEvent[ev.id].petugasFemale++;
      }

      const amt = Number(p.donationAmount || 0);
      perEvent[ev.id].donationTotal += amt;
    });

    totals.pesertaMale += perEvent[ev.id].pesertaMale;
    totals.pesertaFemale += perEvent[ev.id].pesertaFemale;
    totals.petugasMale += perEvent[ev.id].petugasMale;
    totals.petugasFemale += perEvent[ev.id].petugasFemale;
    totals.donationTotal += perEvent[ev.id].donationTotal;
  });

  // ==================================
  //   HITUNG PRA-REG (BELUM HADIR)
  // ==================================
  (preRegistrations || []).forEach((pr) => {
    const gender = getGender(pr);
    const male = isMale(gender);
    const isPeserta = !!pr.peserta;

    if (isPeserta) {
      if (male) preTotals.pesertaMale++;
      else preTotals.pesertaFemale++;
    } else {
      if (male) preTotals.petugasMale++;
      else preTotals.petugasFemale++;
    }
  });

  return { perEvent, totals, preTotals };
}
